import React, { useState, useEffect } from 'react'
import { doc, getDoc, runTransaction, increment, setDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '../firebase/firebase'

const LikeButton = ({ itemId, count, anonUid, collectionName = 'news' }) => {
  const [liked, setLiked] = useState(false)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    if (!itemId || !anonUid) return
    getDoc(doc(db, collectionName, itemId, 'likes', anonUid))
      .then(snap => setLiked(snap.exists()))
  }, [itemId, anonUid, collectionName])

  const toggle = async () => {
    if (!anonUid || busy) return
    const wasLiked = liked
    setLiked(!wasLiked)
    setBusy(true)
    try {
      const mainRef = doc(db, collectionName, itemId)
      const likeRef = doc(db, collectionName, itemId, 'likes', anonUid)
      if (wasLiked) {
        await runTransaction(db, async (tx) => {
          const snap = await tx.get(mainRef)
          const current = snap.data()?.likesCount || 0
          tx.delete(likeRef)
          tx.set(mainRef, { likesCount: Math.max(0, current - 1) }, { merge: true })
        })
      } else {
        await runTransaction(db, async (tx) => {
          tx.set(likeRef, { likedAt: serverTimestamp() })
          tx.set(mainRef, { likesCount: increment(1) }, { merge: true })
        })
      }
    } catch {
      setLiked(wasLiked)
    } finally {
      setBusy(false)
    }
  }

  return (
    <button
      onClick={toggle}
      disabled={busy || !anonUid}
      style={{
        background: 'none',
        border: 'none',
        cursor: anonUid && !busy ? 'pointer' : 'default',
        padding: '6px 0',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        fontSize: '14px',
        color: liked ? '#c0392b' : '#b8a090',
        fontFamily: '"Segoe UI", system-ui, sans-serif',
        transition: 'color 0.15s',
        opacity: busy ? 0.6 : 1,
      }}
      aria-label={liked ? 'Прибрати лайк' : 'Сподобалось'}
    >
      <span style={{ fontSize: '16px', lineHeight: 1 }}>{liked ? '❤️' : '🤍'}</span>
      {(count || 0) > 0 && (
        <span style={{ fontWeight: '600' }}>{count}</span>
      )}
    </button>
  )
}

export default LikeButton
